var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"static-tip",style:({
        left: _vm.$store.state.tip.left + 'px',
        top: _vm.$store.state.tip.top + 'px',
        'display': _vm.$store.state.tip.show ? 'inline-block' : 'none'
    }),domProps:{"innerHTML":_vm._s(_vm.$store.state.tip.text)}})}
var staticRenderFns = []

export { render, staticRenderFns }